import { COMPANIES_ID_TOKEN } from "../Reducers/companiesIdTokenReducer";
import { fetchCompaniesIdToken } from "../Util/queries";

export const getCompaniesIdToken = () => async (dispatch) => {
    try {
        const response = await fetchCompaniesIdToken();
        dispatch({
            type: COMPANIES_ID_TOKEN,
            payload: response.data.signedToken
        });
    } catch (error) {
        console.error(error);
        dispatch({
            type: COMPANIES_ID_TOKEN,
            payload: null
        });
    }
}; 
